module.exports = __webpack_public_path__ + "static/media/icon_blue_down_arrow.ea178ff3.png";